import { format } from 'date-fns';

import { Characters } from '../../common/helpers/unicode.helper';
import { DemandDefinitionReferencePeriodFormat } from '../types/DemandDefinitionReferencePeriodFormat';

interface DemandDefinitionReferencePeriodProps {
    formatVariant: DemandDefinitionReferencePeriodFormat;
    referencePeriod: {
        from?: Date;
        to?: Date;
    };
}

export const DemandDefinitionReferencePeriod = ({
    formatVariant,
    referencePeriod,
}: DemandDefinitionReferencePeriodProps) => {
    const formatDate = (dateFormat: string, date?: Date) => {
        if (!date) {
            return '';
        }

        return format(date, dateFormat);
    };

    switch (formatVariant) {
        case DemandDefinitionReferencePeriodFormat.DATE:
            return (
                <>
                    {formatDate('MMM d, yyyy', referencePeriod.from)}
                    {Characters.NO_BREAK_SPACE}
                    {Characters.EN_DASH}
                    {Characters.NO_BREAK_SPACE}
                    {formatDate('MMM d, yyyy', referencePeriod.to)}
                </>
            );
        case DemandDefinitionReferencePeriodFormat.SHORT_MONTH:
            return (
                <>
                    {formatDate('MMM', referencePeriod.from)}
                    {Characters.NO_BREAK_SPACE}
                    {formatDate('yy', referencePeriod.from)}
                    {Characters.NO_BREAK_SPACE}
                    {Characters.HYPHEN_MINUS}
                    {Characters.NO_BREAK_SPACE}
                    {formatDate('MMM', referencePeriod.to)}
                    {Characters.NO_BREAK_SPACE}
                    {formatDate('yy', referencePeriod.to)}
                </>
            );
        case DemandDefinitionReferencePeriodFormat.MONTH:
            return (
                <>
                    {formatDate('MMM yyyy', referencePeriod.from)}
                    {Characters.NO_BREAK_SPACE}
                    {Characters.EN_DASH}
                    {Characters.NO_BREAK_SPACE}
                    {formatDate('MMM yyyy', referencePeriod.to)}
                </>
            );
    }
};
